<template>
    <div>
        <!-- <div class="header">
             <div class="select">
                 类型：
                 <el-select v-model="typeValue" placeholder="请选择">
                     <el-option
                             v-for="item in types"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                     </el-option>
                 </el-select>
             </div>
             <el-button type="danger">拒绝</el-button>
             <el-button type="success">同意</el-button>
         </div>-->

        <div class="common-table">
            <el-table v-loading="loading" :data="tribeJoin.beanList" row-key="msgId" height="100%">
                <!--<el-table-column type="selection" width="55"/>-->
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="俱乐部ID" align="center" prop="clubId"/>
                <el-table-column label="俱乐部昵称" align="center" prop="clubName"/>
                <el-table-column label="联盟名称" align="center" prop="tribeName"/>
                <el-table-column label="留言框" align="center" prop="message"/>
                <el-table-column label="申请时间" align="center" prop="createTime"/>
                <el-table-column align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="reject(scope.row.msgId)">拒绝</el-button>
                        <el-button type="success" size="mini" @click="approve(scope.row.msgId)">同意</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination class="common-el-pagination"
                       layout="prev,pager,next,jumper"
                       background
                       :page-size="20"
                       :pager-count="5"
                       :current-page="currentPage"
                       @current-change="getList($event)"
                       :total="tribeJoin.total"/>

    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading:false,
                currentPage: 1
            }
        },
        computed: {
            ...mapState('managementMsg', ['tribeJoin'])
        },
        created() {
            this.getList(this.currentPage)
        },
        methods: {
            ...mapActions('managementMsg', ['getTribeJoinList', 'approveTribeJoin', 'rejectTribeJoin']),
            getList(page = 1){
                this.loading = true;

                this.getTribeJoinList(page).then(()=>{
                    this.loading = false
                });
            },
            approve(msgId) {
                this.approveTribeJoin(msgId).then(() => {
                    this.$message.success('申请已批准');
                    this.getList(this.currentPage);
                })
            },
            reject(msgId) {
                this.rejectTribeJoin(msgId).then(() => {
                    this.$message.success('申请已拒绝');
                    this.getList(this.currentPage);
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        display: flex;
    }

    .select {
        flex: 1;
    }

    .el-icon-setting:hover {
        cursor: pointer;
    }
</style>